"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Palette = void 0;
const Color_1 = __importDefault(require("../Color"));
exports.Palette = {
    //Rebrand HexCodes
    HelixSecondaryBoldAccent: new Color_1.default('#056D78'),
    HelixNotificationBold: new Color_1.default('#E30072'),
    HelixSecondaryBoldHighlight: new Color_1.default('#22A3AF'),
    HelixBackgroundPrimarySubtleHighlight: new Color_1.default('#F4F5F9'),
    HelixWarningBold: new Color_1.default('#D11723'),
    HelixDenotiveWarning: new Color_1.default('#FFE066'),
    HelixOrange40: new Color_1.default('#FF9800'),
    HelixDenotiveSuccess: new Color_1.default('#1EDF92'),
    ParadisePink: new Color_1.default('#F4496D'),
    SeaGreen: new Color_1.default('#5BA8A1'),
    OceanBlue: new Color_1.default('#3B5385'),
    MaastrichtBlue: new Color_1.default('#011936'),
    Overlay: new Color_1.default('#111114'),
    Liquorice: new Color_1.default('#1C110A'),
    BlackCoral: new Color_1.default('#59656F'),
    PastelBlue: new Color_1.default('#B5C2CA'),
    LavendarGrey: new Color_1.default('#BDC9D7'),
    BorderGrey: new Color_1.default('#EBECF2'),
    InputCardGrey: new Color_1.default('#E8E9EE'),
    InputBorderGrey: new Color_1.default('#B8C1C6'),
    BackgroundGrey: new Color_1.default('#F0F1F6'),
    Platinum: new Color_1.default('#DEE4E7'),
    CardKeyline: new Color_1.default('#E2E3EB'),
    WhiteSmoke: new Color_1.default('#F4F5F9'),
    Black: new Color_1.default('#000000'),
    White: new Color_1.default('#FFFFFF'),
    LineGrey: new Color_1.default('#D5DCE5'),
    GreyBlue: new Color_1.default('#8A939D'),
    LighterGrey: new Color_1.default('#A7AABC'),
    Grey: new Color_1.default('#EBECF2'),
    MediumSeaGreen: new Color_1.default('#00BB6C'),
    Greeny: new Color_1.default('#2DCA73'),
    CoralRed: new Color_1.default('#FF3E41'),
    TimelineRed: new Color_1.default('#FE5449'),
    TimelineGreen: new Color_1.default('#09AC84'),
    OJ: new Color_1.default('#FF810E'),
    Indigo: new Color_1.default('#6A439C'),
    MustardYellow: new Color_1.default('#FFA826'),
    MellowYellow: new Color_1.default('#FFC212'),
    LightPurple: new Color_1.default('#858FBB'),
    NoteYellow: new Color_1.default('#FFF0D6'),
    GoodOldBlue: new Color_1.default('#3A86FF'),
    LightBlue: new Color_1.default('#ECF3FF'),
    LibertyPurple: new Color_1.default('#5158BB'),
    BadRed: new Color_1.default('#FF5959'),
    GoodGreen: new Color_1.default('#0AD1A1'),
    MediumBlue: new Color_1.default('#577CFF'),
    NicerGreen: new Color_1.default('#65d26e'),
    Transparent: new Color_1.default('rgba(0, 0, 0, 0)'),
    // THe following should populated by the THEME
    primary: undefined,
    secondary: undefined,
    positive: undefined,
    warning: undefined,
    black: undefined,
    error: undefined,
    progress: undefined,
};
exports.Palette.primary = exports.Palette.HelixNotificationBold;
exports.Palette.secondary = exports.Palette.HelixSecondaryBoldHighlight;
exports.Palette.black = exports.Palette.HelixSecondaryBoldAccent;
exports.Palette.positive = exports.Palette.HelixDenotiveSuccess;
exports.Palette.progress = exports.Palette.LibertyPurple;
exports.Palette.error = exports.Palette.HelixWarningBold;
exports.Palette.warning = exports.Palette.HelixDenotiveWarning;
exports.default = exports.Palette;
